import styles from "./spark.module.scss";
import { Box } from "@mui/material";
import classnames from "classnames";
import PropTypes from "prop-types";
import { Button, Flex, Icon } from "ui";

export function Spark({
  buttonText,
  children,
  className,
  disabled,
  hidden,
  onClick,
  ...props
}) {
  if (hidden) return null;

  return (
    <Flex
      className={classnames(styles.root, className)}
      justifyContent="center"
      {...props}
    >
      <Box className={styles.spark}>
        <Icon name="auto_awesome" />
      </Box>
      <Flex spacing={1}>
        {children}
        <Button
          disabled={disabled}
          onClick={onClick}
          size="medium"
          variant="text"
        >
          {buttonText || "Comenzar"}
        </Button>
      </Flex>
    </Flex>
  );
}

Spark.propTypes = {
  buttonText: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};
